export class NuevoServicioDTO {
    constructor(
        public descripcion: string,
        public precioDesde: number,
        public precioHasta: number,
        public idUnidadMedida: number,
        public idUnidadTiempo: number,
        public atributos: string[]
    ) {
        this.descripcion=descripcion;
        this.precioDesde=precioDesde;
        this.precioHasta=precioHasta;
        this.idUnidadMedida=idUnidadMedida;
        this.idUnidadTiempo=idUnidadTiempo;
        this.atributos=atributos;
    }
}